import type { FC } from 'react';
import React, { useContext, useEffect } from 'react';
import { signOutAndClearStorage } from 'venn-api';
import { UserContext, AuthLoading } from 'venn-components';
import { logExceptionIntoSentry, resetAnalyticsUser } from 'venn-utils';

const Logout: FC<React.PropsWithChildren<unknown>> = () => {
  const userContext = useContext(UserContext);
  useEffect(() => {
    const logout = async () => {
      // Analytics providers hold their own session cookies, so they have to be torn down before the
      // page navigates away or the next user of this browser inherits the session. Signing out must
      // still proceed if that fails.
      try {
        await resetAnalyticsUser();
      } catch (error) {
        logExceptionIntoSentry(error as Error);
      }

      try {
        await signOutAndClearStorage();
      } catch (_e) {
        // If there's a failure supress it because it is likely the user
        // is already un-authenticated, so reload the page to show the
        // login screen
      }
      window.location.href = `${process.env.PUBLIC_URL}/`;
    };
    // If we have a current user, log them out
    if (userContext?.profileSettings?.user?.id) {
      logout();
      // Otherwise reload the page so the user can see the sign-in screen
    } else {
      window.location.reload();
    }
  }, [userContext]);

  // The only thing rendered by this route is the loader
  return <AuthLoading />;
};

export default Logout;
